import React,{Component} from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { Redirect } from "react-router-dom";
import ChromeCheck from "views/ChromeCheck.jsx";
import tenMinutes from "components/10-mins.jpg";
import ReadAloud from "components/Question/Speaking/ReadAloud.jsx";
import DescribeImage from "components/Question/Speaking/DescribeImage.jsx";
import RepeatSentece from "components/Question/Speaking/RepeatSentece.jsx";
import RetellLec from "components/Question/Speaking/RetellLec.jsx";
import ShortQue from "components/Question/Speaking/ShortQue.jsx";
import Summary from "components/Question/Writting/Summary.jsx";
import Essay from "components/Question/Writting/Essay.jsx";
import SingleAnswer from "components/Question/Reading/SingleAnswer.jsx";
import MultipleAnswer from "components/Question/Reading/MultipleAnswer.jsx";
import Reorder from "components/Question/Reading/Reorder.jsx";
import ReadingBlank from "components/Question/Reading/ReadingBlank.jsx";
import WrittingBlank from "components/Question/Reading/WrittingBlank.jsx";
import Summer from "components/Question/Listening/Summer.jsx";
import McqSingle from "components/Question/Listening/McqSingle.jsx";
import McqMulti from "components/Question/Listening/McqMulti.jsx";
import ListeningBlank from "components/Question/Listening/ListeningBlank.jsx";
import MissingWord from "components/Question/Listening/MissingWord.jsx";
import CorrectSummary from "components/Question/Listening/CorrectSummary.jsx";
import Dictation from "components/Question/Listening/Dictation.jsx";
import Highlight from "components/Question/Listening/Highlight.jsx";
import ResourceCheck from "./ResourceCheck.jsx";
// core components
import { NavLink } from "react-router-dom";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import API from "api.js";
import {store} from 'store/index';
import { setAlert} from 'action/index.js';
class Test extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionData:[],
      currentQuestion:0,
      isRecording: false,
      blobURL: '',
      isBlocked: false,
      type:'',
      result:{},
      finalResult:[],
      lastFlag:true,
      resultId:false,
      secondCount:0,
      submitProcess:false,
      saveProcess:false,
      dashboardFlag:false,
      resourceTested:false,
      mockCat:false,
      mockTime:20,
      title:'',
      modal:false,
      pending:0,
      msg:'',
      qTime:0,
      nextType:0,
      stopRecording:false,
      soundStat:true,
      soundModal: false,
      soundArr:[2,4,5,13,14,15,16,17,18,19,20],
      q_count:0,
      timeOutFlag:false,
      listeningArr:[],
      speakingArr:[],
      readingArr:[],
      writtingArr:[],
      fullArr:[],
      testIndex:0,
      timeArr:[],
      typeArr:[],
      skip:0,
      stopTimer:true,
      changePhase:false,
      curr_q:0,
      waitFlag:true,
      all_ok:true,
      ids:[],
      submittedId:[],
      complete:0
    };
  }
/*2,4,5,13,14,15,16,17,18,19,20*/
  componentDidMount() {
    let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    this.setState({all_ok:isChrome});
    document.body.classList.toggle("sidebar-mini");
    document.body.classList.toggle("sidebar-test-close");
    //document.querySelector('#minimizeSidebar').style.display = "none"
    API({
        method: 'GET',
        url: 'question/detail/'+this.props.match.params.id+'/'+this.props.match.params.pending
      }).then(data => {
        let speak = [];
        let write = [];
        let read = [];
        let listen = [];
        let fullArr = [];
        let timeArr = [];
        let typeArr =[];
        data.data.mock.question.map((v) =>{
          if ([1,2,3,4,5,6,7].includes(v.subcategory_id)) {
            speak.push(v)
          }
          /*else if([6,7].includes(v.subcategory_id)){
            write.push(v)
          }*/
          else if([8,9,10,11,12].includes(v.subcategory_id)){
            read.push(v)
          }else if([13,14,15,16,17,18,19,20].includes(v.subcategory_id)){
            listen.push(v);
          }
        });
        if (true) {
          fullArr.push(speak);
          timeArr.push(data.data.mock.speaking_time+data.data.mock.writting_time);
          typeArr.push(1);    
        }
        /*if (write.length > 0) {
          fullArr.push(write);
          timeArr.push(data.data.mock.writting_time);
          typeArr.push(2);
        }*/

        if (true) {
          fullArr.push(read);
          timeArr.push(data.data.mock.reading_time);
          typeArr.push(2);
        }

        if (true) {
          fullArr.push(listen);
          timeArr.push(data.data.mock.listening_time);
          typeArr.push(3);
        }
        
        console.log(speak);
       // console.log(write);
        console.log(read);
        console.log(listen);
        console.log(timeArr);
        this.setState({ids:fullArr[data.data.skip],typeArr:typeArr,timeArr:timeArr,fullArr:fullArr,listeningArr:listen,speakingArr:speak,writtingArr:write,readingArr:read,title:data.data.mock.title,mockCat:data.data.mock.category,skip:data.data.skip,testIndex:data.data.skip,'questionData':fullArr[data.data.skip],type:fullArr[data.data.skip][0].subcategory_id});
        var intervalId = setInterval(this.timer, 1000);
        let soundStat = true;
        if (this.state.soundArr.includes(this.state.questionData[0].subcategory_id)) {
          soundStat=false;
        }
        let timeVar = timeArr[data.data.skip];
        if (this.props.match.params.pending == 1) {
          timeVar = data.data.time;
        }
        this.setState({q_count:data.data.q_count,curr_q:data.data.curr_q,soundStat:soundStat,intervalId: intervalId,secondCount:parseFloat(timeVar)*60,mockTime:parseFloat(timeVar)*60});
        
    }).catch(()=>{
      
    });
      navigator.getUserMedia({ audio: true },
        () => {
          console.log('Permission Granted');
          this.setState({ isBlocked: false });
        },
        () => {
          console.log('Permission Denied');
          this.setState({ isBlocked: true })
        },
      );

  }

  nextSection = (e) => {
      this.setState({ids:this.state.fullArr[this.state.testIndex],curr_q:0,currentQuestion:0,changePhase:false,questionData:this.state.fullArr[this.state.testIndex],type:this.state.fullArr[this.state.testIndex][0].subcategory_id});  
    
  }

  submitResponse = (data,f=false) => {
    
    let obj = {
      data:data.data,
      text_answer:data.answer,
      length:data.length,
      correct:data.correct
    };
    if (f) {
        
      
    }else{
      this.setState({result:obj});    
    }
    
  } 

  resultStatus = () => {
    this.setState({is_result:true});

  }

  timer = () => {
    if (this.state.secondCount === 1) {
      //this.setState({dashboardFlag:true,timeOutFlag:true});
      if(this.state.typeArr[this.state.testIndex] == 3 && this.state.waitFlag){
        this.skipWait();
        return true;
      }
      this.nextButton('d',3);
      let bodyFormData = new FormData();
      let time = 0;
      bodyFormData.append('mock_id', this.props.match.params.id);
      if (this.state.timeArr.length == this.state.testIndex +1) {
        bodyFormData.append('time', 0);  
        time = 0;
      }else{
        bodyFormData.append('time', this.state.timeArr[this.state.testIndex+1]);  
        time = this.state.timeArr[this.state.testIndex+1];
      }

      //this.state.ids this.state.questionData[this.state.currentQuestion]
      this.state.ids.map((v,k) => {
        if (k!==0) {
          bodyFormData.append('id[]', v.id );
        }
      });
      API({
        method: 'Post',
        url: 'set/mockTime',
        data:bodyFormData
      }).then(data => {

        this.setState({secondCount:time*60})
      }).catch(()=>{
      
    });
      
    }
    if (this.state.stopTimer) {
      this.setState({ secondCount: this.state.secondCount -1,qTime: this.state.qTime+1 });  
    }
    
  }

  componentWillUnmount = () => {
    document.body.classList.toggle("sidebar-mini");
    document.body.classList.toggle("sidebar-test-close");
    //document.querySelector('#minimizeSidebar').style.display = "block"
    clearInterval(this.state.intervalId);
  }

  nextButton = (e,p) => {
    if (!this.state.soundStat) {
      this.setState({soundModal:true});
    }else{
      let pending = 0;
      let msg ="";
      let complete = 0;
      if (p ===0) {
        pending = 0;
        msg = "Do you want to go to next Question?";
      }else if(p === 1){
        pending = 0;
        msg = "Do you want to submit this section?";
        complete = 1;
      }else if(p === 3){
        pending = 1;
        msg = "Timeout";
      }else if(p === 2){
        msg = "Do you want to save this question and exit mock test?";
        pending = 1;
      }
      this.setState({'modal':true,'pending':pending,msg:msg,nextType:p,complete:complete});  
    }
    

  }

  toggleYes = () => {
    this.setState({
        stopRecording: true
    });
    
  }

   nextQuestion = async (obj) =>{
    let obj2 = {
      data:obj.data,
      text_answer:obj.answer,
      length:obj.length,
      correct:obj.correct,
      second:obj.time,
      lang:obj.lang,
      html: obj.html,
      audio_text:obj.audio_text,
      duration:obj.duration
    };
      let obj1 = await this.finalObjectCreation(obj2);
      //if (this.state.nextType !== 3) {
        this.finalSubmit(obj1,this.state.nextType);
      //}
      
      if(this.state.nextType === 1){
        if (this.state.fullArr.length >= this.state.testIndex+2) {
          this.setState({stopRecording:false,modal:false,stopTimer:true,testIndex:(this.state.testIndex+1),changePhase:true,nextType:3,secondCount:parseFloat(this.state.timeArr[this.state.testIndex+1])*60,mockTime:parseFloat(this.state.timeArr[this.state.testIndex+1])*60},function(){
            if(this.state.typeArr[this.state.testIndex] == 3 && this.state.waitFlag){
                this.setState({secondCount:600,mockTime:600})
            }
          });  
        }else{
          this.setState({stopRecording:false,modal:false,dashboardFlag:true}); 
          store.dispatch(setAlert({'flag':true,'type':1,'message':"Mock submitted successfully"}));
        }
        
      }else if(this.state.nextType === 3){
        if (this.state.fullArr.length >= this.state.testIndex+2) {
          this.setState({stopRecording:false,modal:false,stopTimer:true,testIndex:(this.state.testIndex+1),changePhase:true,nextType:3});  
        }else{
          this.setState({stopRecording:false,modal:false,dashboardFlag:true}); 
          store.dispatch(setAlert({'flag':true,'type':1,'message':"Mock submitted successfully"}));
        }
        
      }else if(this.state.nextType === 2){
          this.setState({stopRecording:false,modal:false,dashboardFlag:true}); 
          store.dispatch(setAlert({'flag':true,'type':1,'message':"Mock submitted successfully"}));
      }else if(this.state.nextType === 0){
        let soundStat = true;
        if (this.state.soundArr.includes(this.state.questionData[this.state.currentQuestion+1].subcategory_id)) {
          soundStat=false;
        }
      this.setState({soundStat:soundStat,stopRecording:false,result:{},currentQuestion:this.state.currentQuestion + 1,type:this.state.questionData[this.state.currentQuestion+1].subcategory_id,modal:false},()=>{
        this.forceUpdate();  
      });
    }
    
  }

  skipWait = () => {
    this.setState({waitFlag:false,secondCount:parseFloat(this.state.timeArr[this.state.testIndex])*60,mockTime:parseFloat(this.state.timeArr[this.state.testIndex])*60});
  }

  finalSubmit = (obj1, type) =>{
    let curr = this.state.questionData[this.state.currentQuestion]; 
    let obj = [];
    let time = this.state.secondCount;
    let tFlag = false;
    obj.push(obj1);
    let finalArr = [];
    /*if(this.state.lastFlag){
      finalArr = [...this.state.finalResult,obj];
      this.setState({finalResult:[...this.state.finalResult,obj],lastFlag:false})
    }else{
      finalArr = this.state.finalResult;
    }*/
      let bodyFormData = new FormData();
      if(this.props.match.params.pending == 1){
        bodyFormData.append('result_id', this.props.match.params.id);  
      }
      bodyFormData.append('q_count', this.state.questionData.length);
      bodyFormData.append('mock_id', this.props.match.params.id);
      bodyFormData.append('q_time', this.state.qTime);
      bodyFormData.append('complete', this.state.complete);
      if (this.state.secondCount <= 0) {
        if (this.state.timeArr.length == this.state.testIndex +1) {
          bodyFormData.append('time', 0);  
        }else{
          bodyFormData.append('time', this.state.timeArr[this.state.testIndex+1]*60);  
        }
      }else{
        bodyFormData.append('time', this.state.secondCount);
      }
      
      bodyFormData.append('pending', this.state.pending);
      if (type == 1) {
        bodyFormData.append('skip', 1);
      }
      if (this.state.questionData.length == this.state.currentQuestion+1) {
        bodyFormData.append('curr_q', 0);  
      }else{
        bodyFormData.append('curr_q', this.state.currentQuestion + this.state.curr_q + 1);
      }
      
      console.log(obj);
      obj.map((v,k) => {
        if ([6,7,13].includes(v.type)) {
          tFlag = true;
          time = (this.state.secondCount-v.second);
          if (time < 1) {
            time = 1
          }
          //this.setState({secondCount: (this.state.secondCount-v.second)})
          bodyFormData.append('time', time );
          
        }else{
          time = this.state.secondCount;
          bodyFormData.append('time', this.state.secondCount);
        }
        bodyFormData.append('response[]',v.response);
        if([1,2,3,4,5].includes(v.type)){
          bodyFormData.append('text[]', v.answer);
          bodyFormData.append('selected[]', v.text_answer);
          bodyFormData.append('text_answer[]', v.text_answer);
          bodyFormData.append('answer[]', v.ans);
          bodyFormData.append('lang[]', v.lang);
          bodyFormData.append('html[]', v.html);
          bodyFormData.append('audio_text[]', v.audio_text);
          bodyFormData.append('q_ans[]', v.q_ans);
          bodyFormData.append('length[]', v.length);
          bodyFormData.append('ans[]', v.q_ans);
          bodyFormData.append('duration[]', v.duration);
          if (v.data == "") {
            bodyFormData.append('file[]',  new Blob(['hello worllllllllllllld']));  
          }else if(v.data === undefined){
            bodyFormData.append('file[]',  new Blob(['hello worlppppppppppppd']));
          }else{
            bodyFormData.append('file[]', v.data);
          }
          
          bodyFormData.append('type[]', v.type);
          bodyFormData.append('correct[]', v.correct);
          bodyFormData.append('script[]', v.script);
          bodyFormData.append('id[]', v.id);
        }else if([6,7].includes(v.type)){
            bodyFormData.append('text[]', v.answer);
            bodyFormData.append('text_answer[]', v.text_answer);
            bodyFormData.append('selected[]', v.text_answer);
            bodyFormData.append('type[]', v.type);
            bodyFormData.append('audio_text[]', v.audio_text);
            bodyFormData.append('answer[]', v.q_ans);
            bodyFormData.append('script[]', v.script);
            bodyFormData.append('ans[]', v.q_ans);
            bodyFormData.append('lang[]', v.lang);
            bodyFormData.append('html[]', v.html);
            bodyFormData.append('file[]',  new Blob(['hello worlppppppppppppd']));
            bodyFormData.append('correct[]', v.correct);
            bodyFormData.append('length[]', v.length);
            bodyFormData.append('id[]', v.id);
            bodyFormData.append('q_ans[]', v.q_ans);
            bodyFormData.append('duration[]', v.duration); 
        }
        else if([8,9,10,11,12].includes(v.type)){
          bodyFormData.append('text[]', v.answer);
          bodyFormData.append('selected[]', v.text_answer);
          bodyFormData.append('type[]', v.type);
          bodyFormData.append('lang[]', v.lang);
          bodyFormData.append('text_answer[]', v.text_answer);
          bodyFormData.append('answer[]', v.correct);
          bodyFormData.append('script[]', v.script);
          bodyFormData.append('correct[]', v.correct);
          bodyFormData.append('ans[]', v.q_ans);
          bodyFormData.append('length[]', v.length);
          bodyFormData.append('id[]', v.id);
          bodyFormData.append('audio_text[]', v.audio_text);
          bodyFormData.append('html[]', v.html);
          bodyFormData.append('file[]',  new Blob(['hello worlppppppppppppd']));
          bodyFormData.append('q_ans[]', v.q_ans);
          bodyFormData.append('duration[]', v.duration);
        }
        else if([13,14,15,17,19,20,18,16].includes(v.type)){
            bodyFormData.append('text[]', v.answer);
            bodyFormData.append('selected[]', v.text_answer);
            bodyFormData.append('type[]', v.type);
            bodyFormData.append('answer[]', v.correct);
            bodyFormData.append('lang[]', v.lang);
            bodyFormData.append('script[]', v.script);
            bodyFormData.append('ans[]', v.q_ans);
            bodyFormData.append('correct[]', v.correct);
            bodyFormData.append('length[]', v.length);
            bodyFormData.append('html[]', v.html);
            bodyFormData.append('audio_text[]', v.audio_text);
            bodyFormData.append('text_answer[]', v.text_answer);
            bodyFormData.append('id[]', v.id);
            bodyFormData.append('file[]',  new Blob(['hello worlppppppppppppd']));
            bodyFormData.append('q_ans[]', v.q_ans);
            bodyFormData.append('duration[]', v.duration);
        }
      });
      /*if (flag) {
        this.setState({saveProcess:true});
        bodyFormData.append('pending', 1);
      }else{
        this.setState({submitProcess:true});
        bodyFormData.append('pending', 0);
      }*/
      
      API({
          method: 'POST',
          url: 'submit/mock',
          data:bodyFormData
        }).then(data => {
          console.log(data);

           let filteredAry = this.state.ids.filter(function(e) { return e.id !== obj[0].id });
          if (tFlag) {
            this.setState({secondCount: time,qTime:0,ids:filteredAry});  
          }else{
            this.setState({qTime: 0,ids:filteredAry});
          }
          
          if (data.status ===200 && data.data.status === 200) {
            /*if (flag) {
              this.setState({submitProcess:false,dashboardFlag:true});  
            }else{
              this.setState({'resultId':data.data.id,submitProcess:false});
            }*/
           // store.dispatch(setAlert({'flag':true,'type':1,'message':data.data.message}));
          }else{
            this.setState({submitProcess:false});
            store.dispatch(setAlert({'flag':true,'type':2,'message':"Something went wrong."}));
          }
      }).catch(()=>{
      
    });
    
  }


  toggle = () =>{
    this.setState({modal:!this.state.modal});
  }

  soundChecked = () =>{
    this.setState({soundStat:true});
  }

  showTest = () => {
    this.setState({resourceTested:true,secondCount:this.state.mockTime});
    this.forceUpdate();
  }

  closeSoundModal = () => {
    this.setState({soundModal:false});
  }

  getTypeName = () => {
    let type = "d";
    //alert(this.state.typeArr[this.state.testIndex])
    switch(this.state.typeArr[this.state.testIndex]){
      case 1:
        type = "Speaking & Writting";
        break;
      case 2:
        type = "Reading Test";
        break;
      case 3:
        type = "Listening Test";
        break;
    }
    return type;
  }

  closeTimeoutModal = () => {
    this.setState({timeOutFlag:false});
  }

  finalObjectCreation = (obj1 = false) => {
    let qdata = this.state.questionData[this.state.currentQuestion];
    let response = true;
    if (Object.keys(this.state.result).length === 0 ) {
     response = true;
    }
    let obj = {};
    if (obj1) {
      obj = {
      ...obj1,
      type:qdata.subcategory_id,
      id:qdata.id,
      response:response,
      answer:qdata.question,
      script:qdata.audio_script,
      q_ans:qdata.answer
    } 
    }else{
      obj = {
      ...this.state.result,
      type:qdata.subcategory_id,
      id:qdata.id,
      response:response,
      answer:qdata.question,
      script:qdata.audio_script,
      q_ans:qdata.answer
    }  
    }
    return obj;
  }

  
  render() {
    console.log(this.state.ids);
      let props ={
      submit:this.submitResponse,
      showResult:this.resultStatus,
      data:this.state.questionData[this.state.currentQuestion],
      resultMode:false,
      testMode:true,
      soundChecked:this.soundChecked,
      stopRecording:this.state.stopRecording,
      nextQuestion:this.nextQuestion
    };
    let que;
    let title ="";
    let ques_title ="";
    if (this.state.questionData.length >0) {
      ques_title = this.state.questionData[this.state.currentQuestion].q_title;
    }
    switch(this.state.type) {
      case 1:
        que = <ReadAloud {...props} />;
        title = "Look at the text below. In the 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud.";
        break;
      case 2:
        que = <RepeatSentece {...props} />;
        title = "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.";
        break;
      case 3:
        que = <DescribeImage {...props} />;
        title = "Look at the Image below. In 25 seconds,please speak into the microphone and describe in detail what the graph showing. You will have 40 seconds to give your response.";
        break;
      case 4:
        que = <RetellLec {...props} />;
        title = "You will hear a lecture. After listening to the lecture, in 10 seconds, please speak into the microphone and retell what you have just heard from the lecture in your own words. You will have 40 seconds to give your response.";
        break;
      case 5:
        que = <ShortQue {...props} />;
        title = "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.";
        break;
      case 6:
        que = <Summary {...props} />;
        title = "Read the passage and summarize it using one sentence. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. your response will be judge on the quality of your writing and on how well your response presents the key points in the passage.";
        break;
      case 7:
        que = <Essay {...props} />;
        title = "You will have 20 minutes to plan, write and revise an essay about the topic below. your response will be judged on how well you develop a position, oraganize your ideas, present supporting details, and control the elements of standard written English. You should write 200-300 words.";
        break;
      case 8:
        que = <SingleAnswer {...props} />;
        title = "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
        break;
      case 9:
        que = <MultipleAnswer {...props} />;
        title = "Read the text and answer the question by selecting all the correct responses. More than one response is correct.";
        break;
      case 10:
        que = <Reorder {...props} />;
        title = "The textbox in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel.";
        break;
      case 11:
        que = <ReadingBlank {...props} />;
        title = "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text.";
        break;
      case 12:
        que = <WrittingBlank {...props} />;
        title = "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.";
        break;
      case 13:
        que = <Summer {...props} />;
        title = "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should wirte 50-70 words. You have 10 minutes to finish the task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture.";
        break;
      case 14:
        que = <McqSingle {...props} />;
        title = "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
        break;
      case 15:
        que = <McqMulti {...props} />;
        title = "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.";
        break;
      case 16:
        que = <ListeningBlank {...props} />;
        title = "You will hear a recording. Type the missing words in each blank.";
        break;
      case 17:
        que = <CorrectSummary {...props} />;
        title = "You will hear a recording. Click on the paragraph that best relates to the recording.";
        break;
      case 18:
        que = <MissingWord {...props} />;
        title = "You will hear a recording about "+ ques_title+". At the end of the recording the last word or group of words has benn replaced by a beep. Select the correct option to complete the recording";
        break;
      case 19:
        que = <Highlight {...props} />;
        title = "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.";
        break;
      case 20:
        que = <Dictation {...props} />;
        title = "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.";
        break;
      default:
        // code block
    }

    return (
      <>
      {!this.state.all_ok && <ChromeCheck />}
      {this.state.all_ok && <>
      {this.state.timeOutFlag && <Modal isOpen={this.state.timeOutFlag} size="sm"  >
                      
                      <ModalBody>
                        <div>Test stopped due to timeout.</div>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="secondary" className="modalCloseBtn" onClick={this.closeTimeoutModal}>OK</Button>
                      </ModalFooter>
                    </Modal>}
      {this.state.soundModal && <Modal isOpen={this.state.soundModal} size="sm"  >
                      
                      <ModalBody>
                        <div>Please wait for question audio to be finished.</div>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="secondary" className="modalCloseBtn" onClick={this.closeSoundModal}>OK</Button>
                      </ModalFooter>
                    </Modal>}
        {this.state.modal && <Modal isOpen={this.state.modal} size="sm"  >
                      
                      <ModalBody>
                        <div>{this.state.msg}</div>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="secondary" className="modalCloseBtn" onClick={this.toggleYes}>{this.state.nextType != 3 && "Yes"} {this.state.nextType == 3 && "Ok"}</Button>
                       {this.state.nextType != 3 && <Button color="secondary" className="modalCloseBtn" onClick={this.toggle}>No</Button> } 
                      </ModalFooter>
                    </Modal>}
      {this.state.typeArr && !this.state.resourceTested && <ResourceCheck showTest={this.showTest} pending={this.props.match.params.pending} data={{'type':this.state.typeArr,'full':this.state.fullArr,'time':this.state.timeArr}} cat={5} />}
      
        {!this.state.dashboardFlag && !this.state.changePhase && this.state.resourceTested && <div className="content questionsArea">
                  <Row>
                    <Col xs={12}>
                      <Card>
                        <CardHeader>
                          <Row>
                            <Col xs={6}>
                              <CardTitle tag="h4">
                                {this.state.title}
                              </CardTitle>
                            </Col>
                            <Col xs={6}>
                              <div className="text-right questionTime">
                                <div className="timeRemaining">
                                  <p><i class="fa fa-clock-o"></i> <span>Time Remaining: {Math.floor(this.state.secondCount / 60) +':'+ parseInt(this.state.secondCount % 60)}</span></p>
                                </div>
                                <div className="item">
                                  <p>Question {this.state.currentQuestion+ this.state.curr_q +1} of {this.state.questionData.length + this.state.curr_q}</p>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                          {title}
                          <Row className='unselectable'>
                          {this.state.secondCount === 0 && <div>Time up please restart the Test</div> }     
                          {this.state.secondCount !== 0 &&  this.state.questionData && que }
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xs={12}><div className="bottomBtns">
                      <Row>
                      <Col xs={9}>
                      {!this.state.dashboardFlag && !this.state.saveProcess && !this.state.resultId && this.state.currentQuestion > 0  && this.state.questionData.length !== (this.state.currentQuestion+1) && <Button color="primary" onClick={(e) => this.nextButton(e,2)}  size="xs">Save & Exit</Button>}
                        {this.state.saveProcess &&  !(this.state.questionData.length != (this.state.currentQuestion+1)) && <Button color="primary"  size="xs">Wait...</Button>}
                      {!this.state.dashboardFlag && !this.state.submitProcess && this.state.secondCount !==0 && !this.state.resultId &&  !(this.state.questionData.length != (this.state.currentQuestion+1)) && <Button color="primary" onClick={(e) => this.nextButton(e,1)}  size="xs">Submit</Button>}
                      {this.state.submitProcess &&  !(this.state.questionData.length != (this.state.currentQuestion+1)) && <Button color="primary"  size="xs">Wait...</Button>}
        
                      {this.state.submitProcess &&  !(this.state.questionData.length != (this.state.currentQuestion+1)) && <Button color="primary"  size="xs">Wait...</Button>}
                      {this.state.resultId && <NavLink to={'/admin/result/'+this.state.resultId} > <Button color="primary"  size="xs">Show Result</Button> </NavLink>  }
                      {this.state.dashboardFlag && <NavLink to={'/admin/dashboard'} > <Button color="primary"  size="xs">Go to Dashboard</Button> </NavLink>  }
                      {this.state.timeOutFlag && <div>Test stopped due to timeout</div>}
                      </Col>
                      <Col xs={3}>
                            {!this.state.dashboardFlag && this.state.secondCount !==0 && !this.state.resultId && (this.state.questionData.length != (this.state.currentQuestion+1)) && this.state.questionData.length!==0 && <Button color="primary" onClick={(e) => this.nextButton(e,0)} size="xs">NEXT</Button>}         
                      </Col>
                      </Row>
                      </div>
                    </Col>
                  </Row>
                </div>}

                {this.state.dashboardFlag && <div className="content questionsArea">
                  <Row>
                    <Col xs={12}>
                      <Card>
                        <CardHeader>
                          <Row>
                            <Col xs={6}>
                              <CardTitle tag="h4">
                                {this.state.title}
                              </CardTitle>
                            </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                          <Row className='testFinish unselectable'>
                            <div className="col-sm-12">
                              <h4 className="mt-0">Submit Activity</h4>
                              <p>The test is now complete. Your report will be available soon in the <strong>Tests Finished area</strong>.</p>
                              <NavLink to={'/admin/result'} > <button class="btn">Continue</button></NavLink>
                            </div>
                
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xs={12}><div className="bottomBtns">
                      <Row>
                      <Col xs={12}>
                      
                      {this.state.dashboardFlag && <NavLink to={'/admin/dashboard'} > <Button color="primary"  size="xs">Go to Dashboard</Button> </NavLink>  }
                      {this.state.timeOutFlag && <div>Test stopped due to timeout</div>}
                      </Col>
                      </Row>
                      </div>
                    </Col>
                  </Row>
                </div>}
          {this.state.changePhase && (this.state.typeArr[this.state.testIndex] != 3 || (this.state.typeArr[this.state.testIndex] == 3 && !this.state.waitFlag) ) && <div className="content questionsArea">
                  <Row>
                    <Col xs={12}>
                      <Card>
                        <CardHeader>
                          <Row>
                            <Col xs={6}>
                              <CardTitle tag="h4">
                                {this.state.title}
                              </CardTitle>
                            </Col>
                            <Col xs={6}>
                              <div className="text-right questionTime">
                                
                                 
                                </div>
                              
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                         
                           <Row className='unselectable'>
                            <div className="col-lg-12">
                            <div className="timeRemaining">
                                  <p><i class="fa fa-clock-o"></i> <span>Time Remaining: {Math.floor(this.state.secondCount / 60) +':'+ parseInt(this.state.secondCount % 60)}</span></p>
                            </div>
                     <h4 class="mt-0">Welcome {store.getState().user.first_name} {store.getState().user.last_name}</h4>
                      <div class="col-xs-12">
                        <table className="table table-bordered">
                          <tr>
                            <th>Section</th>
                            <th>No of Question</th>
                            <th>Time Allowed</th>
                          </tr>
                          <tr>
                            <td>{this.getTypeName()}</td>
                            <td>{this.state.fullArr[this.state.testIndex].length}</td>
                            <td>{this.state.timeArr[this.state.testIndex]} minutes</td>
                          </tr>
                        </table>
                      </div>
                      </div>
                            </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xs={12}><div className="bottomBtns">
                      <Row>
                      <Col xs={9}>
                      {<Button color="primary" onClick={(e) => this.nextSection(e)} size="xs">Start Next Section</Button>}
                      
                      </Col>
                      <Col xs={3}>
                                   
                      </Col>
                      </Row>
                      </div>
                    </Col>
                  </Row>
                </div>}

                {this.state.changePhase && (this.state.typeArr[this.state.testIndex] == 3 && this.state.waitFlag) && <div className="content questionsArea">
                  <Row>
                    <Col xs={12}>
                      <Card>
                        <CardHeader>
                          <Row>
                            <Col xs={6}>
                              <CardTitle tag="h4">
                                {this.state.title}
                              </CardTitle>
                            </Col>
                            <Col xs={6}>
                              <div className="text-right questionTime">
                                
                                 
                                </div>
                              
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                         
                           <Row className='unselectable'>
                            <div className="col-lg-12">
                            <div className="timeRemaining">
                                  <p><i class="fa fa-clock-o"></i> <span>Time Remaining: {Math.floor(this.state.secondCount / 60) +':'+ parseInt(this.state.secondCount % 60)}</span></p>
                            </div>
                            
                            <h4 className="mt-0">Optional Break</h4>
                            <h6>You may now take a break up to 10 minutes. If you want to take a break you must leave the testing room.</h6>
                            <ol>
                              <li>If you want to take a break raise your hand to get the attention of the Test Administrator.</li>
                              <li>If you do not want to take a break click on next button below to continue the test.</li>
                            </ol>
                            <img src={tenMinutes} />
                  
                      </div>
                            </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xs={12}><div className="bottomBtns">
                      <Row>
                      <Col xs={9}>
                      {<Button color="primary" onClick={(e) => this.skipWait(e)} size="xs">Skip wait</Button>}
                      
                      </Col>
                      <Col xs={3}>
                                   
                      </Col>
                      </Row>
                      </div>
                    </Col>
                  </Row>
                </div>}
      </>}
      </>
    );
  }
}

export default Test;
